<template>
  <footer
    class="flex min-h-9 items-center justify-between gap-4 border-t border-border bg-bg-elevated/85 px-6 py-2 text-xs text-text-secondary backdrop-blur-sm"
  >
    <ul class="m-0 flex list-none flex-wrap items-center gap-5 p-0">
      <li
        v-for="hint in hints"
        :key="hint.id"
        class="inline-flex items-center gap-2 text-text-secondary"
      >
        <KeyHint :label="hint.key" :size="KeyHintSize.Sm" :variant="hint.variant ?? KeyHintVariant.Default" />
        <span class="font-base tracking-[0.02em]">{{ hint.label }}</span>
      </li>
    </ul>
    <slot />
  </footer>
</template>

<script setup lang="ts">
import KeyHint, { KeyHintSize, KeyHintVariant } from './KeyHint.vue'
import type { KeyHintVariant as KeyHintVariantType } from './KeyHint.vue'

export interface StatusBarHint {
  /**
   * Stable per-hint id. Required so Vue's `:key` never collides when two
   * hints happen to share a key/label pair — concatenating those strings
   * produced duplicate-key warnings before.
   */
  readonly id: string
  readonly key: string
  readonly label: string
  readonly variant?: KeyHintVariantType
}

export interface StatusBarProps {
  readonly hints: ReadonlyArray<StatusBarHint>
}

defineProps<StatusBarProps>()
</script>